import { Browse, BrowseID } from "@/models/browse";

export class BrowseSearchSettings {
	Clients: string[] = [];
	Supliers: string[] = [];
	Prospects: string[] = [];
	Products: string[] = [];
	Stock: string[] = [];
	Sales: string[] = [];
	Bank: string[] = [];
	SaleRows: string[] = [];
	Subscriptions: string[] = [];
	Purchase: string[] = [];
	SupplierPurchase: string[] = [];
	Cars: string[] = [];
	ProspectDocuments:string[] = [];
	DiverseLedgers:string[] = [];
	PurchaseDocumentSaleRows:string[] = [];
	Crm:string[] = [];
	LedgerAccounts:string[] = [];
	Bookkeeping:string[] = [];
	Projects:string[] = [];
	SaleRowsExtraBookYearsToSearch:number = 0;
	PurchaseDocumentRowExtraBookYearsToSearch:number = 0;

	constructor(data?: any) {
		if (!data) return;
		this.Clients = data.Clients || [];
		this.Supliers = data.Supliers || [];
		this.Prospects = data.Prospects || [];
		this.Products = data.Products || [];
		this.Stock = data.Stock || [];
		this.Sales = data.Sales || [];
		this.Bank = data.Bank || [];
		this.SaleRows = data.SaleRows || [];
		this.Subscriptions = data.Subscriptions || [];
		this.Purchase = data.Purchase || [];
		this.SupplierPurchase = data.SupplierPurchase || [];
		this.Cars = data.Cars || [];
		this.ProspectDocuments = data.ProspectDocuments || [];
		this.DiverseLedgers = data.DiverseLedgers || [];
		this.PurchaseDocumentSaleRows = data.PurchaseDocumentSaleRows || [];
		this.Crm = data.Crm || [];
		this.LedgerAccounts = data.LedgerAccounts || [];
		this.Bookkeeping = data.Bookkeeping || [];
		this.Projects = data.Projects || [];
		this.SaleRowsExtraBookYearsToSearch = data.SaleRowsExtraBookYearsToSearch || 0;
		this.PurchaseDocumentRowExtraBookYearsToSearch = data.PurchaseDocumentRowExtraBookYearsToSearch || 0;
	}

	getJSON() {
		return {
			Clients: this.Clients,
			Supliers: this.Supliers,
			Prospects: this.Prospects,
			Products: this.Products,
			Stock: this.Stock,
			Sales: this.Sales,
			SaleRows: this.SaleRows,
			Bank: this.Bank,
			Subscriptions: this.Subscriptions,
			Purchase: this.Purchase,
			SupplierPurchase: this.SupplierPurchase,
			Cars: this.Cars,
			ProspectDocuments: this.ProspectDocuments,
			DiverseLedgers: this.DiverseLedgers,
			PurchaseDocumentSaleRows: this.PurchaseDocumentSaleRows,
			Crm: this.Crm,
			LedgerAccounts: this.LedgerAccounts,
			Bookkeeping: this.Bookkeeping,
			Projects: this.Projects,
			SaleRowsExtraBookYearsToSearch: this.SaleRowsExtraBookYearsToSearch,
			PurchaseDocumentRowExtraBookYearsToSearch: this.PurchaseDocumentRowExtraBookYearsToSearch,
		};
	}
	// eslint-disable-next-line max-lines-per-function
	getSettings(browse:Browse | number):string[] {
		let browseId = 0;
		if (typeof(browse) == "number"){
			browseId = browse;
		}else{
			browseId = browse.ID;
		}
		if (browseId == BrowseID.CLIENTS) {
			return this.Clients;
		}else if (browseId == BrowseID.SUPPLIERS) {
			return this.Supliers;
		}else if (browseId == BrowseID.PROSPECTS) {
			return this.Prospects;
		}else if (browseId == BrowseID.PRODUCTS) {
			return this.Products;
		}else if  (browseId == BrowseID.STOCKIN) {
			return this.Stock;
		}else if (browseId == BrowseID.SALES) {
			return this.Sales;
		}else if (browseId == BrowseID.SALE_ROWS) {
			return this.SaleRows;
		}else if (browseId == BrowseID.BANK) {
			return this.Bank;
		}else if (browseId == BrowseID.PURCHASE) {
			return this.Purchase;
		}else if (browseId == BrowseID.SUBSCRIPTIONS) {
			return this.Subscriptions;
		}else if (browseId == BrowseID.PURCHASE_DOCUMENTS) {
			return this.SupplierPurchase;
		}else if (browseId == BrowseID.CARS) {
			return this.Cars;
		}else if (browseId == BrowseID.PROSPECT_DOCUMENTS) {
			return this.ProspectDocuments;
		}else if (browseId == BrowseID.DIVERSE_LEDGERS){
			return this.DiverseLedgers;
		}else if (browseId == BrowseID.PURCHASE_DOCUMENT_ROWS) {
			return this.PurchaseDocumentSaleRows;
		}else if (browseId == BrowseID.CRM) {
			return this.Crm;
		}else if (browseId == BrowseID.LEDGER_ACCOUNTS){
			return this.LedgerAccounts;
		}else if (browseId == BrowseID.BOOKKEEPING) {
			return this.Bookkeeping;
		}else if (browseId == BrowseID.PROJECT) {
			return this.Projects;
		}
		throw new Error("No such config");
	}
}